import React from "reactn";
import SectionOne from "./forms/SectionOne";
import SectionTwo from "./forms/SectionTwo";
class Setup extends React.Component {
  render() {
    console.log("PROPS:", this.props);
    return (
      <div className="cont boxes-row mt-50px" style={{ display: "flex", alignItems: "flex-start", gap: "20px" }}>
        <SectionOne
          initialAddChild={this.props.initialAddChild}
          initialManualInvoices={this.props.initialManualInvoices}
          initialApplicationRequired={this.props.initialApplicationRequired}
          initialTransactionCost={this.props.initialTransactionCost}
          allowSameEnrollment={this.props.allowSameEnrollment}
          vals={this.global.myApplicationProfileInfo}
        />
        <SectionTwo vals={this.global.myApplicationProfileInfo} />
      </div>
    );
  }
}

export default Setup;
